import { mergeObjectTypes } from '../cacheHelpers';

const Money = {
  merge: mergeObjectTypes
};

export default Money;
